export default {
  LIST_FETCHED: 'SUBDOMAIN_FETCHED',
  LIST_LOAD: 'SUBDOMAIN_LOAD',
  ITEM_DETAIL: 'SUBDOMAIN_DETAIL',
  BUTTON_LOAD: 'SUBDOMAIN_BUTTON_LOAD',
};
